import React from "react";
import { FOOTER } from "../../../layout/kor/footer";
import { SUBHEADER } from "../../../layout/kor/subheader";
import { Organization } from "../../../parts/kor/intro/organization";
export const ORGANIZATION = () => {
  return (
    <main id="content">
      <SUBHEADER />
      <div id="intro">
        <Organization />
      </div>
      <FOOTER />
    </main>
  );
};
